import PartnerLandingTemplate from '@/components/template/PartnerLandingTemplate';
import { PartnerTemplate } from '@/components/template/PartnerTemplate/PartnerTemplate';
import { SEOMetaTags } from '@/lib/seo/seoTags';
import { BasePageProps } from '@/types/page';

const Partner = () => {
  return (
    <main>
      {process.env.NEXT_PUBLIC_NEW_PARTNER_PAGE === 'true' ? (
        <PartnerTemplate />
      ) : (
        <PartnerLandingTemplate />
      )}
    </main>
  );
};

export const getStaticProps = async () => {
  return {
    props: {
      metadata: {
        title: SEOMetaTags.partnerPage.title,
        description: SEOMetaTags.partnerPage.description,
      },
    } satisfies BasePageProps,
  };
};

export default Partner;
